import { styled } from '@mui/system';

export const StyledTray = styled('div')(({ theme }) => ({
  background: theme.palette.background.paper,
  overflowX: 'hidden !important',
  overflowY: 'hidden !important',
  margin: '0px',
  padding: '0px',
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  right: 0,
  width: '400px',
  top: '0px',
  height: '100%',
  minHeight: 0,
  borderRadius: '6px !important',
  border: `1px solid ${theme.palette.divider}`,
  zIndex: 50,
  animation: 'fadeInSlideLeft 0.3s ease-out',
  '@keyframes fadeInSlideLeft': {
    '0%': {
      opacity: 0,
      transform: 'translateX(20px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
}));

export const StyledTrayContent = styled('div')(() => ({
  flex: 1,
  overflowY: 'auto',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));
